import React from 'react';

import { Button, Modal, ModalHeading } from '@components/common';
import { WarningSVG } from '@components/svgs';

// Default messages for different contexts
const DEFAULT_MESSAGES = {
  SINGLE_RULE: 'Are you sure you want to delete this rule? This will remove all conditional logic and answer tagging.',
  ALL_RULES:
    'Are you sure you want to delete all rules from this question? This will delete all rules, conditional logic, and answer tagging.'
} as const;

const DEFAULT_TITLES = {
  SINGLE_RULE: 'Delete rule',
  ALL_RULES: 'Remove all logic'
} as const;

interface DeleteRuleModalProps {
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message?: string;
  /**
   * Pre-configured context for common use cases
   * 'single' - for deleting individual rules
   * 'all' - for removing all rules
   */
  context?: 'single' | 'all';
}

export const DeleteRuleModal: React.FC<DeleteRuleModalProps> = ({
  onClose,
  onConfirm,
  title,
  message,
  context = 'single'
}) => {
  // Determine title and message based on context or use provided values
  const modalTitle = title || (context === 'all' ? DEFAULT_TITLES.ALL_RULES : DEFAULT_TITLES.SINGLE_RULE);
  const modalMessage = message || (context === 'all' ? DEFAULT_MESSAGES.ALL_RULES : DEFAULT_MESSAGES.SINGLE_RULE);

  return (
    <Modal size='sm' onClose={onClose}>
      <div className='mb-4 flex items-center space-x-3'>
        <div className='flex-shrink-0'>
          <WarningSVG className='h-6 w-6 text-red-500' aria-hidden='true' />
        </div>
        <ModalHeading className='text-gray-900'>{modalTitle}</ModalHeading>
      </div>

      <p className='mb-6 text-sm text-gray-600'>{modalMessage}</p>

      <div className='flex justify-end space-x-3'>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onConfirm} danger>
          {context === 'all' ? 'Remove all logic' : 'Delete rule'}
        </Button>
      </div>
    </Modal>
  );
};
